var videoSuffics = [".mp4", ".mov", ".wmv", ".flv", ".avi", ".mkv"];
var youtubeUrl = "https://www.youtube.com/";
var youtubeEmbed = "embed";
var youtubeDomains = [
    "www.youtube.com",
    "m.youtube.com",
    "youtube.com",
    "youtu.be",
];
export var isUrlYoutubeVideo = function (url) {
    if (!url)
        return false;
    var normalized = url.toLowerCase();
    normalized = normalized.replace(/^https?:\/\//, "");
    for (var i = 0; i < youtubeDomains.length; i++) {
        if (normalized.indexOf(youtubeDomains[i] + "/") === 0)
            return true;
    }
    return false;
};
var isVideo = function (link) {
    if (!link)
        return false;
    link = link.toLowerCase();
    for (var i = 0; i < videoSuffics.length; i++) {
        if (link.endsWith(videoSuffics[i]))
            return true;
    }
    return false;
};
export var calculateRenderedMode = function (contentMode, imageLink) {
    if (contentMode && contentMode !== "auto")
        return contentMode;
    if (isUrlYoutubeVideo(imageLink))
        return "youtube";
    if (isVideo(imageLink))
        return "video";
    return "image";
};
export var getCorrectImageLink = function (val, isYouTube) {
    if (!val || !isUrlYoutubeVideo(val))
        return isYouTube ? "" : val || "";
    var res = val.toLocaleLowerCase();
    if (res.indexOf(youtubeEmbed) > -1)
        return val;
    var id = "";
    for (var i = val.length - 1; i >= 0; i--) {
        if (val[i] === "=" || val[i] === "/")
            break;
        id = val[i] + id;
    }
    return youtubeUrl + youtubeEmbed + "/" + id;
};
export var getRenderedSize = function (val) {
    if (typeof val === "string") {
        if (!isNaN(Number(val)))
            return Number(val);
        if (val.includes("px"))
            return parseFloat(val);
    }
    if (typeof val === "number")
        return val;
    return undefined;
};
export var getRenderedStyleSize = function (val) {
    if (getRenderedSize(val) !== undefined)
        return undefined;
    return val;
};
export var getLocale = function () {
    return typeof navigator !== "undefined" ? navigator.language || "" : "";
};
export var getLocaleText = function (value, loc) {
    if (loc === void 0) { loc = getLocale(); }
    if (!value)
        return "";
    if (typeof value === "string")
        return value;
    var keys = Object.keys(value);
    if (!keys.length)
        return "";
    var findKey = function (target) {
        return target ? keys.find(function (key) { return key.toLowerCase() === target; }) : undefined;
    };
    var locale = loc.toLowerCase();
    var rootDialect = locale.split("-")[0];
    var key = findKey(locale) || findKey(rootDialect) || findKey("default") || keys[0];
    return value[key] || "";
};
